import React from 'react';
import { Typography, Button, SxProps, Theme } from '@mui/material';

interface TmCancelButtonProps {
    onClick: () => void;
    children: string;
    width?: string;
    disabled?: boolean;
    sx?: SxProps<Theme>;
  }

  
const TmEmptyButton: React.FC<TmCancelButtonProps> = ({ onClick, children, width = "10%", disabled = false, sx}) => {
    return (
        <Button 
        style={{
            border: "1px",
            borderRadius: "25px",
            borderStyle: "solid",
            borderColor: "#9588e8",
            paddingLeft: "2em",
            paddingRight: "2em",
            paddingTop: "0.8em",
            paddingBottom: "0.8em",
        }}
        
        sx={{ 
            textAlign: "center",
            fontWeight: "bold",
            textTransform: "none",
            backgroundColor: "transparent",
            ":hover": {
                backgroundColor: "transparent",
            },
            ":disabled": {
                backgroundColor: "#e0e0e0 !Important",
                borderColor: "#e0e0e0 !Important",
            },
            color: "#9588e8",
            width: width,
            minWidth: "150px",
            ...sx
        }}
        
        disabled={disabled}
        onClick={onClick}><Typography fontWeight="bold">{children}</Typography></Button>
    );
}

export default TmEmptyButton;
